import occamDataGuardian from "shared/assets/occam-data-guardian.svg";
import galacticaUrl from "shared/assets/svg/galactica-logo.svg";

type Provider = {
  title: string;
  icon: string;
  avgTime: string;
  rate: string;
  type: string;
};

export const providers = [
  import.meta.env.VITE_CHAIN_ID !== "613419" && {
    title: "Sample KYC Provider",
    icon: galacticaUrl,
    avgTime: "3 minutes",
    rate: "5.0",
    type: "gip1",
  },
  {
    title: "Occam data guardian",
    icon: occamDataGuardian,
    avgTime: "3 minutes",
    rate: "5.0",
    type: "gip3",
  },
].filter((provider): provider is Provider => Boolean(provider));
